<div class="check-cell-renderer">
	<app-checkbox [model]="value" [readonly]="true" [roundCheckbox]="true"></app-checkbox>
</div>
